import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { StepsProvider } from "react-step-builder";
import NewRegistrationForm from "./NewRegistrationForm";
const Registration = () => {
    return (_jsx(_Fragment, { children: _jsx(StepsProvider, { children: _jsx(NewRegistrationForm, {}) }) }));
};
export default Registration;
